import React from "react";
import "./HeroSection.css";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaClock,
  FaCheckCircle,
} from "react-icons/fa";

import heroImage from "../assets3/Washing-Machinr-Repairing-95.jpeg";

const HeroSection = () => {
  return (
    <section
      className="jabh-hero-section"
      style={{
        backgroundImage: `url(${heroImage})`,
      }}
    >
      <div className="jabh-hero-overlay">
        <div className="jabh-hero-content">
          <span className="jabh-hero-tag">
            Professional Washing Machine Repair & Service in Surat
          </span>

          <div className="jabh-hero-line"></div>

          <h1>Jay Ambe Washing Machine Services</h1>

          <p>
            Is your washing machine leaking, making noise, or not spinning? We provide 
            expert repair services for all top-load, front-load, and semi-automatic brands 
            directly at your doorstep across Surat. Book today for reliable on-site diagnostics 
            and fast, professional solutions.
          </p>

          <div className="jabh-hero-buttons">
            <a href="tel:+917317596984" className="jabh-call-btn">
              <FaPhoneAlt />
              73175 96984
            </a>

            <a
              href="https://wa.me/917317596984"
              target="_blank"
              rel="noreferrer"
              className="jabh-whatsapp-btn"
            >
              <FaWhatsapp />
              WHATSAPP
            </a>
          </div>
        </div>
      </div>

      <div className="jabh-curve-shape"></div>

      <div className="jabh-feature-box">
        <div className="jabh-feature-item">
          <div className="jabh-feature-icon">
            <FaClock />
          </div>
          <h3>Prompt Doorstep Service</h3>
          <p>
            No need to carry your heavy machine anywhere. Our expert technicians arrive 
            at your doorstep quickly for immediate, on-site diagnostics.
          </p>
        </div>

        <div className="jabh-feature-item">
          <div className="jabh-feature-icon">
            <FaCheckCircle />
          </div>
          <h3>Affordable & Honest Pricing</h3>
          <p>
            Get premium washing machine service at honest, transparent rates 
            with absolutely no hidden or unexpected diagnostic fees.
          </p>
        </div>

        <div className="jabh-feature-item">
          <div className="jabh-feature-icon">
            <FaCheckCircle />
          </div>
          <h3>High-Quality Genuine Parts</h3>
          <p>
            We use genuine, high-quality spare parts to ensure durable repairs
            and long-lasting appliance performance.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;